import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStep from "./workflowStep";

export default class WorkflowDefinition {
  static getWorkflowName(workflowStep: WorkflowStep): string {
    switch (workflowStep.workflow_type) {
      case WorkflowType.approval:
        //TODO: refactor to say which one it is based on if approvals or sections are turned on
        return 'Approval / Form Section';
      case WorkflowType.formSection:
        return 'Form Section';
      case WorkflowType.payment:
        return 'Payment';
      case WorkflowType.form:
        return 'Other Form';
      case WorkflowType.licenseStatusChange:
        return 'License Status Change';
      case WorkflowType.certificate:
        return 'Certificate';
      case WorkflowType.initialStep:
        return 'Initial Step';
      case WorkflowType.mapping:
        return 'Run Mapping';
    }
  }

  static getWorkflowIcon(workflowStep: WorkflowStep): string {
    switch (workflowStep.workflow_type) {
      case WorkflowType.approval:
        //TODO: refactor to say which one it is based on if approvals or sections are turned on
        // return ['~_icon-approval.svg', '_icon-section.svg'];
        return 'approval icon';
      case WorkflowType.form:
        // return ['_icon-form-stack.svg'];
        return 'form-stack icon';
      case WorkflowType.formSection:
        return 'piece icon';
      case WorkflowType.payment:
        return 'payment icon';
      case WorkflowType.licenseStatusChange:
        return 'license icon';
      case WorkflowType.certificate:
        return 'certificate icon';
      case WorkflowType.initialStep:
        return 'piece icon';
      case WorkflowType.mapping:
        return 'mapping-document icon';
    }
  }
}